import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/section.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function Frontier() {
    return (
        <div className="section-container">
            <Header />
            <main className="section-content">
                <p className="section-intro-paragraph">Read about recent advances</p>
                <div className="subsection-links">
                    <Link to="/frontier/prophetnet">ProphetNET</Link>
                    <Link to="/frontier/reformers">Reformers</Link>
                    <Link to="/frontier/electra">ELECTRA</Link>
                    {/* <Link to="/frontier/unifiedqa">UnifiedQA</Link> */}
                    <Link to="/frontier/ctrl">CTRL: Conditional Transformers</Link>
                    <Link to="/frontier/pegasus">Pegasus</Link>
                    <Link to="/frontier/ernie">ERNIE</Link>
                    <Link to="/frontier/future">Future</Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default Frontier;